/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateApiKeyResponse
 */
export interface CreateApiKeyResponse {
    /**
     * The ID of the API key (public portion, not secret).
     * @type {string}
     * @memberof CreateApiKeyResponse
     */
    keyId: string;
    /**
     * The API key itself. You cannot retrieve the API key again.
     * @type {string}
     * @memberof CreateApiKeyResponse
     */
    apiKey: string;
    /**
     * Optional display name.
     * @type {string}
     * @memberof CreateApiKeyResponse
     */
    name?: string | null;
    /**
     * When this key expires, if any.
     * @type {Date}
     * @memberof CreateApiKeyResponse
     */
    expiresAt?: Date | null;
}

/**
 * Check if a given object implements the CreateApiKeyResponse interface.
 */
export function instanceOfCreateApiKeyResponse(value: object): value is CreateApiKeyResponse {
    if (!('keyId' in value) || value['keyId'] === undefined) return false;
    if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
    return true;
}

export function CreateApiKeyResponseFromJSON(json: any): CreateApiKeyResponse {
    return CreateApiKeyResponseFromJSONTyped(json, false);
}

export function CreateApiKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateApiKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'keyId': json['key_id'],
        'apiKey': json['api_key'],
        'name': json['name'] == null ? undefined : json['name'],
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
    };
}

export function CreateApiKeyResponseToJSON(json: any): CreateApiKeyResponse {
    return CreateApiKeyResponseToJSONTyped(json, false);
}

export function CreateApiKeyResponseToJSONTyped(value?: CreateApiKeyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key_id': value['keyId'],
        'api_key': value['apiKey'],
        'name': value['name'],
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
    };
}

